import { ThemePreset } from '../types';

export const THEME_PRESETS: ThemePreset[] = [
  // Dark themes
  {
    id: 'midnight',
    name: 'Midnight',
    description: 'Dark elegance with purple accents',
    category: 'dark',
    colors: {
      background: '#0f0f1a',
      primary: '#8b5cf6',
      secondary: '#6366f1',
      text: '#ffffff',
      accent: '#a78bfa',
    },
    fonts: {
      heading: 'Inter',
      body: 'Inter',
    },
  },
  {
    id: 'daybreak',
    name: 'Daybreak',
    description: 'Deep blue with warm accents',
    category: 'dark',
    colors: {
      background: '#1a1a2e',
      primary: '#e94560',
      secondary: '#16213e',
      text: '#eaeaea',
      accent: '#ff6b6b',
    },
    fonts: {
      heading: 'Poppins',
      body: 'Inter',
    },
  },
  {
    id: 'obsidian',
    name: 'Obsidian',
    description: 'Pure black with cyan highlights',
    category: 'dark',
    colors: {
      background: '#0a0a0a',
      primary: '#06b6d4',
      secondary: '#1e1e1e',
      text: '#f5f5f5',
      accent: '#22d3ee',
    },
    fonts: {
      heading: 'Inter',
      body: 'Inter',
    },
  },

  // Light themes
  {
    id: 'clean-white',
    name: 'Clean White',
    description: 'Minimal and professional',
    category: 'light',
    colors: {
      background: '#ffffff',
      primary: '#2563eb',
      secondary: '#f1f5f9',
      text: '#1e293b',
      accent: '#3b82f6',
    },
    fonts: {
      heading: 'Inter',
      body: 'Inter',
    },
  },
  {
    id: 'soft-cream',
    name: 'Soft Cream',
    description: 'Warm and inviting',
    category: 'light',
    colors: {
      background: '#fefce8',
      primary: '#ca8a04',
      secondary: '#fef9c3',
      text: '#422006',
      accent: '#eab308',
    },
    fonts: {
      heading: 'Playfair Display',
      body: 'Inter',
    },
  },
  {
    id: 'white-roof',
    name: 'White Roof',
    description: 'Clean with blue accents',
    category: 'light',
    colors: {
      background: '#f8fafc',
      primary: '#6366f1',
      secondary: '#e0e7ff',
      text: '#1e1b4b',
      accent: '#818cf8',
    },
    fonts: {
      heading: 'Inter',
      body: 'Inter',
    },
  },

  // Minimal themes
  {
    id: 'basic-wine-red',
    name: 'Basic Wine Red',
    description: 'Sophisticated dark red',
    category: 'minimal',
    colors: {
      background: '#1c1917',
      primary: '#991b1b',
      secondary: '#292524',
      text: '#fafaf9',
      accent: '#dc2626',
    },
    fonts: {
      heading: 'Inter',
      body: 'Inter',
    },
  },
  {
    id: 'sprout',
    name: 'Sprout',
    description: 'Fresh green on dark',
    category: 'minimal',
    colors: {
      background: '#14532d',
      primary: '#22c55e',
      secondary: '#166534',
      text: '#f0fdf4',
      accent: '#4ade80',
    },
    fonts: {
      heading: 'Inter',
      body: 'Inter',
    },
  },
  {
    id: 'basic-light-orange',
    name: 'Basic Light Orange',
    description: 'Warm orange tones',
    category: 'minimal',
    colors: {
      background: '#fff7ed',
      primary: '#ea580c',
      secondary: '#ffedd5',
      text: '#431407',
      accent: '#f97316',
    },
    fonts: {
      heading: 'Inter',
      body: 'Inter',
    },
  },

  // Corporate themes
  {
    id: 'corporate-blue',
    name: 'Corporate Blue',
    description: 'Professional business style',
    category: 'corporate',
    colors: {
      background: '#ffffff',
      primary: '#1e40af',
      secondary: '#dbeafe',
      text: '#1e293b',
      accent: '#2563eb',
    },
    fonts: {
      heading: 'Inter',
      body: 'Inter',
    },
  },
  {
    id: 'bubble-astronaut',
    name: 'Bubble & Astronaut',
    description: 'Space-inspired corporate',
    category: 'corporate',
    colors: {
      background: '#0f172a',
      primary: '#7c3aed',
      secondary: '#1e293b',
      text: '#f1f5f9',
      accent: '#a78bfa',
    },
    fonts: {
      heading: 'Poppins',
      body: 'Inter',
    },
  },
  {
    id: 'executive',
    name: 'Executive',
    description: 'Classic navy and gold',
    category: 'corporate',
    colors: {
      background: '#0c1222',
      primary: '#d4af37',
      secondary: '#1a2744',
      text: '#f8fafc',
      accent: '#fbbf24',
    },
    fonts: {
      heading: 'Playfair Display',
      body: 'Inter',
    },
  },

  // Bold themes
  {
    id: 'neon-night',
    name: 'Neon Night',
    description: 'Vibrant neon on black',
    category: 'bold',
    colors: {
      background: '#000000',
      primary: '#ff00ff',
      secondary: '#1a1a1a',
      text: '#ffffff',
      accent: '#00ffff',
    },
    fonts: {
      heading: 'Poppins',
      body: 'Inter',
    },
  },
  {
    id: 'sunset-gradient',
    name: 'Sunset Gradient',
    description: 'Orange to pink blend',
    category: 'bold',
    colors: {
      background: '#1f1f1f',
      primary: '#f97316',
      secondary: '#2a2a2a',
      text: '#ffffff',
      accent: '#ec4899',
    },
    fonts: {
      heading: 'Poppins',
      body: 'Inter',
    },
  },
  {
    id: 'electric-lime',
    name: 'Electric Lime',
    description: 'High contrast lime green',
    category: 'bold',
    colors: {
      background: '#0a0a0a',
      primary: '#84cc16',
      secondary: '#1a1a1a',
      text: '#f7fee7',
      accent: '#a3e635',
    },
    fonts: {
      heading: 'Inter',
      body: 'Inter',
    },
  },

  // Creative themes
  {
    id: 'pastel-dream',
    name: 'Pastel Dream',
    description: 'Soft pastel colors',
    category: 'creative',
    colors: {
      background: '#fdf2f8',
      primary: '#ec4899',
      secondary: '#fce7f3',
      text: '#831843',
      accent: '#f472b6',
    },
    fonts: {
      heading: 'Playfair Display',
      body: 'Inter',
    },
  },
  {
    id: 'ocean-breeze',
    name: 'Ocean Breeze',
    description: 'Calming sea blues',
    category: 'creative',
    colors: {
      background: '#ecfeff',
      primary: '#0891b2',
      secondary: '#cffafe',
      text: '#164e63',
      accent: '#22d3ee',
    },
    fonts: {
      heading: 'Poppins',
      body: 'Inter',
    },
  },
  {
    id: 'forest-moss',
    name: 'Forest Moss',
    description: 'Earthy green tones',
    category: 'creative',
    colors: {
      background: '#f5f5f4',
      primary: '#65a30d',
      secondary: '#ecfccb',
      text: '#1a2e05',
      accent: '#84cc16',
    },
    fonts: {
      heading: 'Playfair Display',
      body: 'Inter',
    },
  },

  // Professional themes (PowerPoint-style)
  {
    id: 'facet',
    name: 'Facet',
    description: 'Modern geometric blue',
    category: 'professional',
    colors: {
      background: '#1a365d',
      primary: '#4299e1',
      secondary: '#2b6cb0',
      text: '#ffffff',
      accent: '#63b3ed',
    },
    fonts: {
      heading: 'Montserrat',
      body: 'Open Sans',
    },
  },
  {
    id: 'ion-boardroom',
    name: 'Ion Boardroom',
    description: 'Corporate gold elegance',
    category: 'professional',
    colors: {
      background: '#1a1a2e',
      primary: '#c9a227',
      secondary: '#2d2d44',
      text: '#f5f5f5',
      accent: '#e6b800',
    },
    fonts: {
      heading: 'Playfair Display',
      body: 'Open Sans',
    },
  },
  {
    id: 'retrospect',
    name: 'Retrospect',
    description: 'Warm vintage tones',
    category: 'professional',
    colors: {
      background: '#faf5eb',
      primary: '#8b4513',
      secondary: '#f5ebe0',
      text: '#3d2914',
      accent: '#cd853f',
    },
    fonts: {
      heading: 'Merriweather',
      body: 'Lora',
    },
  },
  {
    id: 'slice',
    name: 'Slice',
    description: 'Bold diagonal energy',
    category: 'professional',
    colors: {
      background: '#0d1b2a',
      primary: '#e63946',
      secondary: '#1b263b',
      text: '#f1faee',
      accent: '#ff6b6b',
    },
    fonts: {
      heading: 'Poppins',
      body: 'Inter',
    },
  },
  {
    id: 'frame',
    name: 'Frame',
    description: 'Clean bordered style',
    category: 'professional',
    colors: {
      background: '#ffffff',
      primary: '#2c3e50',
      secondary: '#ecf0f1',
      text: '#2c3e50',
      accent: '#3498db',
    },
    fonts: {
      heading: 'Montserrat',
      body: 'Open Sans',
    },
  },
  {
    id: 'savon',
    name: 'Savon',
    description: 'Soft luxury pastels',
    category: 'professional',
    colors: {
      background: '#fef6f0',
      primary: '#c4a77d',
      secondary: '#f8ede3',
      text: '#4a4a4a',
      accent: '#d4a574',
    },
    fonts: {
      heading: 'Playfair Display',
      body: 'Lora',
    },
  },
  {
    id: 'parallax',
    name: 'Parallax',
    description: 'Depth and layers',
    category: 'professional',
    colors: {
      background: '#0a192f',
      primary: '#64ffda',
      secondary: '#112240',
      text: '#ccd6f6',
      accent: '#5de4c7',
    },
    fonts: {
      heading: 'Inter',
      body: 'Roboto',
    },
  },
  {
    id: 'view',
    name: 'View',
    description: 'Panoramic clarity',
    category: 'professional',
    colors: {
      background: '#f0f4f8',
      primary: '#1a73e8',
      secondary: '#e3f2fd',
      text: '#202124',
      accent: '#4285f4',
    },
    fonts: {
      heading: 'Roboto',
      body: 'Open Sans',
    },
  },
  {
    id: 'gallery',
    name: 'Gallery',
    description: 'Art museum aesthetic',
    category: 'professional',
    colors: {
      background: '#1a1a1a',
      primary: '#ffffff',
      secondary: '#2a2a2a',
      text: '#e0e0e0',
      accent: '#b0b0b0',
    },
    fonts: {
      heading: 'Playfair Display',
      body: 'Inter',
    },
  },
  {
    id: 'metropolitan',
    name: 'Metropolitan',
    description: 'Urban modern style',
    category: 'professional',
    colors: {
      background: '#f8f9fa',
      primary: '#212529',
      secondary: '#e9ecef',
      text: '#343a40',
      accent: '#495057',
    },
    fonts: {
      heading: 'Montserrat',
      body: 'Roboto',
    },
  },
  {
    id: 'wisp',
    name: 'Wisp',
    description: 'Ethereal light gradients',
    category: 'professional',
    colors: {
      background: '#fafbfc',
      primary: '#667eea',
      secondary: '#f0f4ff',
      text: '#2d3748',
      accent: '#764ba2',
    },
    fonts: {
      heading: 'Poppins',
      body: 'Inter',
    },
  },
  {
    id: 'badge',
    name: 'Badge',
    description: 'Achievement-focused',
    category: 'professional',
    colors: {
      background: '#0f0f23',
      primary: '#ffcc00',
      secondary: '#1a1a33',
      text: '#ffffff',
      accent: '#ffd700',
    },
    fonts: {
      heading: 'Montserrat',
      body: 'Inter',
    },
  },
  {
    id: 'quotable',
    name: 'Quotable',
    description: 'Quote-focused design',
    category: 'professional',
    colors: {
      background: '#1e1e2e',
      primary: '#89b4fa',
      secondary: '#313244',
      text: '#cdd6f4',
      accent: '#b4befe',
    },
    fonts: {
      heading: 'Merriweather',
      body: 'Lora',
    },
  },
  {
    id: 'integral',
    name: 'Integral',
    description: 'Mathematical precision',
    category: 'professional',
    colors: {
      background: '#ffffff',
      primary: '#0066cc',
      secondary: '#f5f7fa',
      text: '#1a1a2e',
      accent: '#0099ff',
    },
    fonts: {
      heading: 'Inter',
      body: 'Source Code Pro',
    },
  },
  {
    id: 'ion',
    name: 'Ion',
    description: 'Electric energy vibes',
    category: 'professional',
    colors: {
      background: '#0d0d0d',
      primary: '#00d4ff',
      secondary: '#1a1a1a',
      text: '#ffffff',
      accent: '#00ffcc',
    },
    fonts: {
      heading: 'Poppins',
      body: 'Inter',
    },
  },
  {
    id: 'madison',
    name: 'Madison',
    description: 'Classic elegance',
    category: 'professional',
    colors: {
      background: '#f9f6f2',
      primary: '#8b0000',
      secondary: '#f0ebe4',
      text: '#2c1810',
      accent: '#a52a2a',
    },
    fonts: {
      heading: 'Playfair Display',
      body: 'Merriweather',
    },
  },
  {
    id: 'wood-type',
    name: 'Wood Type',
    description: 'Rustic vintage charm',
    category: 'professional',
    colors: {
      background: '#2d2416',
      primary: '#d4a574',
      secondary: '#3d3123',
      text: '#f4e9d9',
      accent: '#c19552',
    },
    fonts: {
      heading: 'Playfair Display',
      body: 'Merriweather',
    },
  },
  {
    id: 'celestial',
    name: 'Celestial',
    description: 'Deep space cosmos',
    category: 'professional',
    colors: {
      background: '#0b0c10',
      primary: '#66fcf1',
      secondary: '#1f2833',
      text: '#c5c6c7',
      accent: '#45a29e',
    },
    fonts: {
      heading: 'Montserrat',
      body: 'Roboto',
    },
  },
  {
    id: 'vapor-trail',
    name: 'Vapor Trail',
    description: 'Gradient flow design',
    category: 'professional',
    colors: {
      background: '#120136',
      primary: '#ff6b6b',
      secondary: '#1a0a4e',
      text: '#ffffff',
      accent: '#feca57',
    },
    fonts: {
      heading: 'Poppins',
      body: 'Inter',
    },
  },
  {
    id: 'basis',
    name: 'Basis',
    description: 'Minimalist foundation',
    category: 'professional',
    colors: {
      background: '#fefefe',
      primary: '#111111',
      secondary: '#f5f5f5',
      text: '#333333',
      accent: '#666666',
    },
    fonts: {
      heading: 'Inter',
      body: 'Inter',
    },
  },

  // Additional modern themes
  {
    id: 'nordic',
    name: 'Nordic',
    description: 'Scandinavian minimalism',
    category: 'minimal',
    colors: {
      background: '#f7f7f7',
      primary: '#2d3436',
      secondary: '#dfe6e9',
      text: '#2d3436',
      accent: '#74b9ff',
    },
    fonts: {
      heading: 'Inter',
      body: 'Open Sans',
    },
  },
  {
    id: 'aurora',
    name: 'Aurora',
    description: 'Northern lights inspired',
    category: 'creative',
    colors: {
      background: '#0d1b2a',
      primary: '#00b4d8',
      secondary: '#1b263b',
      text: '#e0fbfc',
      accent: '#48cae4',
    },
    fonts: {
      heading: 'Poppins',
      body: 'Inter',
    },
  },
  {
    id: 'terra',
    name: 'Terra',
    description: 'Earthy natural tones',
    category: 'creative',
    colors: {
      background: '#fefae0',
      primary: '#606c38',
      secondary: '#fefee3',
      text: '#283618',
      accent: '#bc6c25',
    },
    fonts: {
      heading: 'Merriweather',
      body: 'Lora',
    },
  },
  {
    id: 'midnight-garden',
    name: 'Midnight Garden',
    description: 'Dark floral elegance',
    category: 'dark',
    colors: {
      background: '#1a1423',
      primary: '#f72585',
      secondary: '#2b1f38',
      text: '#f8f8f2',
      accent: '#7209b7',
    },
    fonts: {
      heading: 'Playfair Display',
      body: 'Inter',
    },
  },
  {
    id: 'cyber-punk',
    name: 'Cyber Punk',
    description: 'Futuristic neon aesthetic',
    category: 'bold',
    colors: {
      background: '#0d0221',
      primary: '#ff2a6d',
      secondary: '#1a0533',
      text: '#d1f7ff',
      accent: '#05d9e8',
    },
    fonts: {
      heading: 'Montserrat',
      body: 'Roboto',
    },
  },
];

// Theme categories for filtering
export const THEME_CATEGORIES = [
  { id: 'all', name: 'All', icon: 'grid' },
  { id: 'professional', name: 'Professional', icon: 'award' },
  { id: 'dark', name: 'Dark', icon: 'moon' },
  { id: 'light', name: 'Light', icon: 'sun' },
  { id: 'minimal', name: 'Minimal', icon: 'minus' },
  { id: 'bold', name: 'Bold', icon: 'zap' },
  { id: 'corporate', name: 'Corporate', icon: 'briefcase' },
  { id: 'creative', name: 'Creative', icon: 'palette' },
] as const;

// Available fonts for typography customization
export const AVAILABLE_FONTS = [
  { id: 'Inter', name: 'Inter', category: 'sans-serif' },
  { id: 'Poppins', name: 'Poppins', category: 'sans-serif' },
  { id: 'Roboto', name: 'Roboto', category: 'sans-serif' },
  { id: 'Open Sans', name: 'Open Sans', category: 'sans-serif' },
  { id: 'Montserrat', name: 'Montserrat', category: 'sans-serif' },
  { id: 'Playfair Display', name: 'Playfair Display', category: 'serif' },
  { id: 'Merriweather', name: 'Merriweather', category: 'serif' },
  { id: 'Lora', name: 'Lora', category: 'serif' },
  { id: 'Source Code Pro', name: 'Source Code Pro', category: 'monospace' },
  { id: 'JetBrains Mono', name: 'JetBrains Mono', category: 'monospace' },
] as const;

// Animation presets
export const SLIDE_TRANSITIONS = [
  { id: 'none', name: 'None', description: 'No transition' },
  { id: 'fade', name: 'Fade', description: 'Smooth fade in/out' },
  { id: 'slide', name: 'Slide', description: 'Slide from right' },
  { id: 'zoom', name: 'Zoom', description: 'Zoom in effect' },
  { id: 'flip', name: 'Flip', description: '3D flip animation' },
  { id: 'cube', name: 'Cube', description: '3D cube rotation' },
  { id: 'dissolve', name: 'Dissolve', description: 'Pixel dissolve' },
] as const;

export const TEXT_ANIMATIONS = [
  { id: 'none', name: 'None', description: 'No animation' },
  { id: 'typewriter', name: 'Typewriter', description: 'Text types in' },
  { id: 'fade-in-up', name: 'Fade Up', description: 'Fade in from below' },
  { id: 'fade-in-down', name: 'Fade Down', description: 'Fade in from above' },
  { id: 'bounce-in', name: 'Bounce', description: 'Bouncy entrance' },
  { id: 'zoom-in', name: 'Zoom', description: 'Scale up entrance' },
] as const;

export const ELEMENT_ANIMATIONS = [
  { id: 'none', name: 'None', description: 'No animation' },
  { id: 'fade-in', name: 'Fade In', description: 'Simple fade' },
  { id: 'slide-up', name: 'Slide Up', description: 'Enter from bottom' },
  { id: 'slide-left', name: 'Slide Left', description: 'Enter from right' },
  { id: 'slide-right', name: 'Slide Right', description: 'Enter from left' },
  { id: 'zoom-in', name: 'Zoom In', description: 'Scale up' },
  { id: 'bounce', name: 'Bounce', description: 'Bouncy entrance' },
  { id: 'flip', name: 'Flip', description: '3D flip in' },
] as const;

// Slide layout formats for variety
export const SLIDE_LAYOUTS = [
  { id: 'title', name: 'Title Slide', description: 'Opening slide with centered title', icon: 'layout' },
  { id: 'title-subtitle', name: 'Title + Subtitle', description: 'Title with subtitle text', icon: 'type' },
  { id: 'title-bullets', name: 'Title + Bullets', description: 'Standard content slide', icon: 'list' },
  { id: 'two-column', name: 'Two Column', description: 'Side by side content', icon: 'columns' },
  { id: 'three-column', name: 'Three Column', description: 'Three content sections', icon: 'layout-grid' },
  { id: 'comparison', name: 'Comparison', description: 'Compare two items', icon: 'git-compare' },
  { id: 'image-left', name: 'Image Left', description: 'Image on left, text on right', icon: 'image' },
  { id: 'image-right', name: 'Image Right', description: 'Text on left, image on right', icon: 'image' },
  { id: 'full-image', name: 'Full Image', description: 'Full bleed image background', icon: 'maximize' },
  { id: 'quote', name: 'Quote', description: 'Featured quotation', icon: 'quote' },
  { id: 'timeline', name: 'Timeline', description: 'Chronological events', icon: 'git-branch' },
  { id: 'stats', name: 'Stats/Numbers', description: 'Key metrics display', icon: 'bar-chart' },
  { id: 'feature-grid-2x2', name: 'Feature Grid 2x2', description: 'Four feature boxes', icon: 'grid' },
  { id: 'feature-grid-3x2', name: 'Feature Grid 3x2', description: 'Six feature boxes', icon: 'grid' },
  { id: 'icon-grid', name: 'Icon Grid', description: 'Icons with descriptions', icon: 'shapes' },
  { id: 'agenda', name: 'Agenda/List', description: 'Numbered list of items', icon: 'list-ordered' },
  { id: 'thank-you', name: 'Thank You', description: 'Closing slide', icon: 'smile' },
  { id: 'section-divider', name: 'Section Divider', description: 'Section break slide', icon: 'minus' },
  { id: 'team', name: 'Team/About', description: 'Team or about section', icon: 'users' },
  { id: 'process-steps', name: 'Process Steps', description: 'Step by step flow', icon: 'arrow-right' },
] as const;

// Helper functions
export function getThemeById(id: string): ThemePreset | undefined {
  return THEME_PRESETS.find((theme) => theme.id === id);
}

export function getThemesByCategory(category: string): ThemePreset[] {
  if (category === 'all') return THEME_PRESETS;
  return THEME_PRESETS.filter((theme) => theme.category === category);
}

// Default presentation customization
export const DEFAULT_TYPOGRAPHY = {
  headingFont: 'Inter',
  bodyFont: 'Inter',
  headingSize: 'large' as const,
  bodySize: 'medium' as const,
  headingWeight: 'bold' as const,
  lineHeight: 'normal' as const,
};

export const DEFAULT_ANIMATIONS = {
  slideTransition: 'fade' as const,
  slideTransitionDuration: 500,
  elementAnimation: 'fade-in' as const,
  textAnimation: 'none' as const,
  autoAdvance: false,
  autoAdvanceDelay: 5,
};
